import React from 'react'
import { AgendamentoContext } from '../../../../contexts/AgendamentoContext'

export default function BttAgend({ item, index, mode }) {
  const { sttCtxAgend, loadAgend, actionsAgend } = React.useContext(AgendamentoContext)

  function VerificaBttAgSel() {
    if (sttCtxAgend.bttAgSel === 'avulsos' && index === 0) {
      return 'btt-agenda-topo-sel btt-radius-left'
    } else if (sttCtxAgend.bttAgSel === 'fixos' && index === 1) {
      return 'btt-agenda-topo-sel'
    } else if (sttCtxAgend.bttAgSel === 'diarias' && index === 2) {
      return 'btt-agenda-topo-sel btt-radius-right'
    } else {
      return 'btt-agenda-topo'
    }
  }

  function VerificaAvulsoSel() {
    if (sttCtxAgend.avulsoSel === 'Todos' && index === 0) {
      return 'btt-agenda-topo-sel btt-radius-left'
    } else if (sttCtxAgend.avulsoSel === 'Avulsos' && index === 1) {
      return 'btt-agenda-topo-sel'
    } else if (sttCtxAgend.avulsoSel === 'Fixos' && index === 2) {
      return 'btt-agenda-topo-sel btt-radius-right'
    } else {
      return 'btt-agenda-topo'
    }
  }

  if (mode) {
    return (
      <button
        key={index}
        style={index === 1 ? { borderLeft: '1px solid #ffd4c7', borderRight: '1px solid #ffd4c7' } : {}}
        className={VerificaBttAgSel()}
        onClick={() => {
          if (!loadAgend.list) {
            if (index === 0) {
              actionsAgend.handleSttCtxAgend('bttAgSel', 'avulsos')
            } else if (index === 1) {
              actionsAgend.handleSttCtxAgend('bttAgSel', 'fixos')
            } else if (index === 2) {
              actionsAgend.handleSttCtxAgend('bttAgSel', 'diarias')
            }
          }
        }}
      >
        {item}
      </button>
    )
  } else {
    return (
      <button
        key={index}
        style={index === 1 ? { borderLeft: '1px solid #ffd4c7', borderRight: '1px solid #ffd4c7' } : {}}
        className={VerificaAvulsoSel()}
        onClick={() => {
          if (!loadAgend.list && !loadAgend.pagina) {
            if (index === 0) {
              actionsAgend.handleSttCtxAgend('avulsoSel', 'Todos')
            } else if (index === 1) {
              actionsAgend.handleSttCtxAgend('avulsoSel', 'Avulsos')
            } else if (index === 2) {
              actionsAgend.handleSttCtxAgend('avulsoSel', 'Fixos')
            }
          }
        }}
      >
        {item}
      </button>
    )
  }
}
